import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import {
  selectEditedUserErrors,
  selectSignupProcessPending,
} from '../../../redux/profiles/selectors';
import { selectAuthStatusInvitationMethod } from '../../../redux/auth/signup/selectors';
import {
  selectCountryList,
  selectEthnicTypes,
  selectGenderTypes,
  selectNameSuffixesList,
  selectRaceTypes,
} from '../../../redux/data/selectors';
import { signupActions } from '../../../redux/auth/signup/actions';
import { loggedUserSelector } from '../../../redux/context/selectors';
import { getSelectOptions } from '../../ProfileLayout/utils/getSelectOptions';
import checkCountryForOrganization from '../../../utils/handleUserData/checkCountryForOrganization';
import parseJSONSafely from '../../../utils/parseJSONSafely';
import { convertGenderList } from '../../../utils/converters/convertListWithLocalization';
import styles from '../index.styl';

const mapStateToProps = state => ({
  races: selectRaceTypes(state),
  profile: loggedUserSelector(state),
  ethnicitys: selectEthnicTypes(state),
  rawGenderList: selectGenderTypes(state),
  nameSuffixList: selectNameSuffixesList(state),
  countriesList: selectCountryList(state),
  pendingProcess: selectSignupProcessPending(state),
  dataValidationErrors: selectEditedUserErrors(state),
  invitationMethod: selectAuthStatusInvitationMethod(state),
  profileEditable: parseJSONSafely(localStorage.getItem('fieldsEditable')),
});

const mapDispatchToProps = {
  confirmSignUp: signupActions.confirm,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({ intl: { formatMessage }, profile, countriesList, rawGenderList }) => {
      const { id, userOrganizations } = profile || {};

      return {
        userId: id,
        formatMessage,
        title: 'titles.signup',
        countries: getSelectOptions(
          countriesList.map(country => country && country.name),
        ),
        genderList: convertGenderList(rawGenderList, formatMessage) || [],
        countryForOrganization: checkCountryForOrganization(userOrganizations),
      };
    },
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Auth/SignUpAzure/enhance.js